export default __webpack_public_path__ + "static/media/blob.f2195ec6.svg";